import React, { useState } from "react";
import DetailsForm from "./DetailsForm";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import styles from "../../_css/AccountSettings.module.css";
import { ToggleSwitch } from "../UI/CustomButtons";
import { ACCOUNT_SETTINGS_DATA } from "../../data/staticDataAccountSettings";
import { useSelector } from "react-redux";

const Index = () => {
  const lang = useSelector((state) => state.language.lang);
  const { accountSettingsTitle, mode, accountSettingsSubTitle ,imageSuccess, userDetailsSavedSuccessfully} = ACCOUNT_SETTINGS_DATA[lang];
  
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);
  return (
    <div>
      <div className={styles.accountSettingsHeader}>
        <div className={styles.accountSettingsHeaderLeft}>
          <i className="cursor-pointer" onClick={() => navigate("/")}>
            <ArrowLeft size={16} />
          </i>
          <h5>{accountSettingsTitle}</h5>
        </div>
        {/* <div className={styles.accountSettingsHeaderRight}>
          <p>{mode}</p>
          <ToggleSwitch
            value={isDarkMode}
            onChange={() => setIsDarkMode(!isDarkMode)}
          />
        </div> */}
      </div>
      <DetailsForm staticData={ACCOUNT_SETTINGS_DATA[lang]}/>
    </div>
  );
};

export default Index;
